import React from 'react';
import {
  Section,
  SettingToggle,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
} from '@views/Settings/components';
import { useDispatch, useSelector } from 'react-redux';
import { setUserMetadataFlag } from '@actions/user';
import { UserMetadataFlag, selectUserMetadata } from '@reducers/user/metadata';

// type Callout = 'nexus' | 'requestBirthdays';
// // This list should be exhaustive as we add more feature callouts
// const userFeatureCallouts: Callout[] = ['nexus', 'requestBirthdays'];

const viewFlags: { label: string; flag: UserMetadataFlag }[] = [
  { label: 'Notes', flag: 'showNotesInSidebar' },
];

export function useViewToggling() {
  const dispatch = useDispatch();
  const userMetadata = useSelector(selectUserMetadata);
  const isEnabled = (flag: UserMetadataFlag) => userMetadata?.[flag] || false;
  const disableView = (flag: UserMetadataFlag) => dispatch(setUserMetadataFlag(flag, false));
  const enableView = (flag: UserMetadataFlag) => dispatch(setUserMetadataFlag(flag, true));
  const toggleView = (flag: UserMetadataFlag) => {
    if (isEnabled(flag)) {
      disableView(flag);
    } else {
      enableView(flag);
    }
  };

  return { isEnabled, toggleView };
}

export default function Sidebar() {
  const { isEnabled, toggleView } = useViewToggling();

  return (
    <Section>
      <SettingsSectionLabel tooltip={undefined}>Show in Sidebar</SettingsSectionLabel>
      <SettingsSectionBox>
        {viewFlags.map(({ label, flag }) => (
          <SettingsSectionRow key={flag}>
            <SettingToggle
              title={label}
              name={flag}
              checked={isEnabled(flag)}
              onChange={() => toggleView(flag)}
            />
          </SettingsSectionRow>
        ))}
      </SettingsSectionBox>
    </Section>
  );
}
